const baseURL = `${process.env.VUE_APP_SERVER_URL}/ProgramaPrestador`;

export const PROGRAMA_PRESTADOR_ACCESS_ERROR =
  "Não foi possível acessar o Questionário de Saúde neste momento. Por favor, tente novamente mais tarde.";

export const PROGRAMA_PRESTADOR_TERM_ERROR =
  "Não foi possível registrar sua resposta ao termo neste momento. Por favor, tente novamente mais tarde.";

export interface ProgramaPrestadorItem {
  DsPrograma: string;
  ProgramaVisivel: boolean;
  HabilitarBotaoAcessar: boolean;
  RequerOptInTermo: boolean;
  CodigoStatus: string | null;
  MensagemInterface: string;
  UrlSsoMarSaude: string | null;
}

export interface ObterProgramaResponse {
  PossuiOptInVigente: boolean;
  Programas: ProgramaPrestadorItem[];
}

export interface ResponderTermoResponse {
  Sucesso: boolean;
}

export interface ObterUrlResponse {
  Url: string;
}

function asPayload<T>(data: unknown, fallback: string): T {
  if (typeof data === "string") {
    throw new Error(data.trim() || fallback);
  }
  if (!data || typeof data !== "object") {
    throw new Error(fallback);
  }
  return data as unknown as T;
}

export function programaPrestadorErrorMessage(error: unknown, fallback: string): string {
  const err = error as { message?: string; response?: { data?: unknown } };
  const data = err?.response?.data;

  if (typeof data === "string" && data.trim()) return data.trim();

  if (data && typeof data === "object") {
    const body = data as Record<string, unknown>;
    const fromBody = body.Error || body.Mensagem || body.MensagemInterface || body.message;
    if (typeof fromBody === "string" && fromBody.trim()) return fromBody.trim();
  }

  if (typeof err?.message === "string" && err.message.trim()) return err.message.trim();

  return fallback;
}

export async function ObterPrograma({ vinculo }: { vinculo: string }): Promise<ObterProgramaResponse> {
  const data = await globalThis.window.$axios
    .get({
      url: `${baseURL}/ObterPrograma`,
      query: { vinculo }
    })
    .then(resp => resp.data);

  return asPayload<ObterProgramaResponse>(data, PROGRAMA_PRESTADOR_ACCESS_ERROR);
}

export async function ResponderTermo({
  vinculo,
  aceite
}: {
  vinculo: string;
  aceite: boolean;
}): Promise<ResponderTermoResponse> {
  const data = await globalThis.window.$axios
    .post({
      url: `${baseURL}/ResponderTermo`,
      query: { vinculo, aceite }
    })
    .then(resp => resp.data);

  const payload = asPayload<ResponderTermoResponse>(data, PROGRAMA_PRESTADOR_TERM_ERROR);
  if (!payload.Sucesso) {
    throw new Error(PROGRAMA_PRESTADOR_TERM_ERROR);
  }
  return payload;
}

export async function ObterUrl({ vinculo }: { vinculo: string }): Promise<ObterUrlResponse> {
  const data = await globalThis.window.$axios
    .get({
      url: `${baseURL}/ObterUrl`,
      query: { vinculo }
    })
    .then(resp => resp.data);

  const payload = asPayload<ObterUrlResponse>(data, PROGRAMA_PRESTADOR_ACCESS_ERROR);
  const url = String(payload.Url || "").trim();
  if (!url) {
    throw new Error(PROGRAMA_PRESTADOR_ACCESS_ERROR);
  }
  return { Url: url };
}
